const ZAPIER_WEBHOOK_PREFIX = 'https://hooks.zapier.com/';

export function isZapierWebhookUrlValid(url: unknown): boolean {
  if (url == null || typeof url !== 'string') return false;
  const trimmed = url.trim();
  return trimmed === '' || trimmed.startsWith(ZAPIER_WEBHOOK_PREFIX);
}
